export default "return PCSS( shadowMap, shadowCoord );"